/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningListEvents } from "../../funcs/llmFineTuningListEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListFineTuningEventsRequest$inboundSchema,
};

export const tool$llmFineTuningListEvents: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-list-events",
  description: `List fine-tuning events

Get status updates for a fine-tuning job.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningListEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
